import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_WorkFlowStep = _resolveComponent("WorkFlowStep");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, {
    class: "page",
    title: "进度"
  }, {
    default: _withCtx(() => [_createVNode(_component_WorkFlowStep, {
      businessId: $data.businessId,
      workFlowDefinitionId: $data.workFlowDefinitionId
    }, null, 8, ["businessId", "workFlowDefinitionId"])]),
    _: 1
  });
}